module.exports = __webpack_public_path__ + "components/flag/static/square/gp-bafc209a0c5fbbb4ca72a3d6d9e6059c.svg";